import React, { useEffect, useState } from "react";

import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { makeStyles } from "@material-ui/core/styles";
import axios from "axios";
import { Button, Grid } from "@mui/material";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import NoRecords from "../NoRecordCard/NoRecord";

const useStyles = makeStyles((theme) => ({
  card: {
    width: 400,
    height: "auto",
    backgroundColor: "#FFFFF",
    borderRadius: "10px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "row",
    color: "rgb(25, 118, 210)",
    margin: "auto",
    border: "1px solid rgb(25, 118, 210)",
    boxShadow: "rgba(16, 3, 21, 0.24) 0px 3px 8px",
  },

  strip: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    marginTop: "5px",
  },
}));

const NotificationChatboard = () => {
  const classes = useStyles();
  const userData = Digit.UserService.getUser() || {};
  console.log("ussseeeerData", userData);
  const authToken = userData?.access_token || null;
  const userRolesArray = userData?.info.roles.filter((user) => user.code !== "EMPLOYEE");
  const userRole = userRolesArray?.[0]?.code;
  const chatBoardStatus = "PENDING";
  const useruuid = userData?.info?.uuid;
  const [notificationData, setNotificationData] = useState([]);
  console.log("Role of User", userRole, notificationData);
  const history = useHistory();
  console.log("Ussssseruuuid", useruuid);

  const handleInboxChatboard = (items, id) => {
    history.push(`/digit-ui/employee/obps/Inbox/chatboard/MAP_SUB/${items}?messageId=${id}`);
  };

  const handlemodalsubmit = async (userRole, chatBoardStatus, useruuid) => {
    const postData = {
      requestInfo: {
        api_id: "1",
        ver: "1",
        ts: null,
        action: "create",
        did: "",
        key: "",
        msg_id: "",
        requester_id: "",
        authToken: authToken,
      },
    };
    try {
      const notificationResult = await axios
        .post(`/land-services/egscrutiny/_search4?userRole=${userRole}&chatBoardStatus=${chatBoardStatus}&useruuid=${useruuid}`, postData, {})
        .then((response) => {
          return response.data;
        });
      console.log("Response of Notifications", notificationResult);
      setNotificationData(notificationResult?.egScrutiny);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    handlemodalsubmit(userRole, chatBoardStatus, useruuid);
  }, [userRole, chatBoardStatus, useruuid]);
  return (
    <div>
      {notificationData.length > 0 ? (
        <div>
          {notificationData?.map((notification, index) => (
            <Card className={classes.card}>
              <CardContent>
                <div className="row" key={index}>
                  <div className="col-6" style={{ width: "75%" }}>
                    <p>{notification.applicationId}</p>
                    <p>{notification.isApproved}</p>
                    <p>{notification.chatBoardStatus}</p>
                    <p style={{ whiteSpace: "nowrap" }}>
                      {notification.employeeName},{notification.designation}
                    </p>
                  </div>
                  <div className="col-6" style={{ width: "25%" }}>
                    <Button
                      size="small"
                      sx={{ ml: 1, fontSize: "11px", float: "right" }}
                      variant="contained"
                      color="success"
                      onClick={() => handleInboxChatboard(notification.applicationId, notification.id)}
                    >
                      Take Action
                    </Button>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
      ) : (
        <div>
          <NoRecords />
        </div>
      )}
    </div>
  );
};

export default NotificationChatboard;
